"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 6H4l8 5z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 13 4 8v10h12v-3.03c0-2.42 1.72-4.44 4-4.9V8z",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M4 18V8l8 5 8-5v2.08c.32-.07.66-.1 1-.1h1V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h12v-2zM20 6l-8 5-8-5z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M23 15v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1m-3 0v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
}, "3")], 'MailLockTwoTone');